module.exports = __webpack_public_path__ + "img/livekid-novakid.55b145b0.png";